import { AxiosResponse } from 'axios'
import SaveTagRequest from 'modules/pedagio/domain/entities/SaveTagRequest'
import TagPedagioResponse from 'modules/pedagio/domain/entities/TagPedagioResponse'
import ITagPedagioRepository from 'modules/pedagio/domain/repositories/ITagPedagioRepository'
import { ServiceConfig } from 'shared/services/ServiceConfig'

const http = new ServiceConfig()

export default class TagPedagioRepository implements ITagPedagioRepository {
  public async findAll(): Promise<TagPedagioResponse> {
    const response: AxiosResponse<TagPedagioResponse> = await http.get(
      'tag-pedagio/disponiveis',
    )

    return response.data
  }

  public async findActiveTag(cpf_motorista: string): Promise<string> {
    const response: AxiosResponse<string> = await http.get(
      `tag-pedagio/motorista/${cpf_motorista}`,
    )

    return response.data
  }

  public async saveTag(request: SaveTagRequest): Promise<void> {
    await http.post('tag-pedagio/preferencial', {
      cpf_motorista: request.cpf_motorista,
      tag_pedagio: request.tag_pedagio,
    })
  }
}
